import React from 'react';
import { X } from 'lucide-react';
import type { BaseCropComponentProps } from '../types';
import { headerContainer, headerTitle, closeButton } from '../styles/index';

interface CropHeaderProps extends BaseCropComponentProps {
  onClose: () => void;
  isLoading?: boolean;
  title?: string;
}

export const CropHeader: React.FC<CropHeaderProps> = ({
  onClose,
  isLoading = false,
  title = 'Crop Image',
  className,
}) => {
  return (
    <div className={`${headerContainer} ${className || ''}`}>
      <h2 className={headerTitle}>{title}</h2>
      <button
        onClick={onClose}
        disabled={isLoading}
        className={closeButton}
        aria-label="Close crop modal"
      >
        <X size={20} />
      </button>
    </div>
  );
};
